export default "__VITE_ASSET__b5176ccc__"